import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SessionsModalTypes } from '../../../../../core/legacy/reducers/modals';
import FailureModal from '../../../../legacy/components/ui/modals/FailureModal';

export const CalibrateFailureModal: FC = () => {
    const { t } = useTranslation();

    return (
        <FailureModal
            title={t('calibrateSession.failure.title')}
            subtitle={t('calibrateSession.failure.subtitle')}
            modalType={SessionsModalTypes.SESSIONS_CALIBRATE_FAILURE}
        />
    );
};
